import React from 'react'

import { Navbar, Footer } from '../../../components';
import { Article3Doc } from '../individual';

export default function Article3() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <Article3Doc />
        <Footer />
    </div>
  )
}
